import {render, html} from 'uhtml';
import './ext';
import stem5Logo from './img/5.png';

const Autodesk = window.Autodesk;
const av = window.av;

const forgeViewerInit = (accessToken, urnId, viewerEl) => {
    let viewer;
    const options = {
        env: 'AutodeskProduction',
        accessToken
    };
    const documentId = `urn:${urnId}`;
    Autodesk.Viewing.Initializer(options, () => {
        Autodesk.Viewing.Document.load(documentId, onDocumentLoadSuccess, onDocumentLoadFailure);
    });

    /**
    * Create a configured dom structure with the necessary styles properties.
    */
    const viewerDiv = document.createElement('div');
    viewerDiv.styles = 'width: 100%; height: 100%; margin: 0;';
    viewerEl.appendChild(viewerDiv);

    /**
    * Add a watermark
    */
    const watermarkDiv = document.createElement('div');
    viewerEl.appendChild(watermarkDiv);

    render(watermarkDiv, html`
        <p class="credits">
            <span>powered by</span>
            <img class="stem5-logo" src="${stem5Logo}" alt="Stem5 Logo">
            <span>stem5</span>
        </p>
    `);

    /**
    * Autodesk.Viewing.Document.load() success callback.
    * Proceeds with model initialization.
    */
    function onDocumentLoadSuccess(doc) {

        // A document contains references to 3D and 2D viewables.
        const viewables = Autodesk.Viewing.Document.getSubItemsWithProperties(doc.getRootItem(), {'type': 'geometry'}, true);
        if (viewables.length === 0) {
            console.error('Document contains no viewables.');
            return;
        }

        // Choose any of the avialble viewables
        const initialViewable = viewables[0];
        const svfUrl = doc.getViewablePath(initialViewable);
        const modelOptions = {
            sharedPropertyDbPath: doc.getPropertyDbPath()
        };

        const config = {
            extensions: ['ModomExtension']
        };

        viewer = new Autodesk.Viewing.Private.GuiViewer3D(viewerDiv, config);
        viewer.start(svfUrl, modelOptions, onLoadModelSuccess, onLoadModelError);

        // Override Key bindings
        const keyup = viewer.impl.controls.handleKeyUp.bind(viewer.impl.controls);
        viewer.impl.controls.handleKeyUp = e => {
            if (e.keyCode === av.KeyCode.ESCAPE) return;
            // Keep the original behaviors
            keyup(e);
        };
    }

    /**
     * Autodesk.Viewing.Document.load() failuire callback.
     */
    function onDocumentLoadFailure(viewerErrorCode) {
        console.error(`onDocumentLoadFailure() - errorCode: ${viewerErrorCode}`);
    }

    /**
     * viewer.loadModel() success callback.
     * Invoked after the model's SVF has been initially loaded.
     * It may trigger before any geometry has been downloaded and displayed on-screen.
     */
    function onLoadModelSuccess(model) {
        console.log('onLoadModelSuccess()!');
        console.log(`Validate model loaded: ${(viewer.model === model)}`);
        console.log(model);
    }

    /**
     * viewer.loadModel() failure callback.
     * Invoked when there's an error fetching the SVF file.
     */
    function onLoadModelError(viewerErrorCode) {
        console.error(`onLoadModelError() - errorCode: ${viewerErrorCode}`);
    }
};

// Login with fixed parameters
const login = () => {
    const loginUrl = 'https://modom-forge-viewer-demo.vercel.app/api/login';

    return fetch(loginUrl, {
        mode: 'cors'
    }).then(response => response.json().then(
        result => result.access_token
    ));
};

const forgeViewerRun = viewerEl => {
    // 2-Legged token auth
    login().then(accessToken => {

        // Model - MDM-MAR-ConfigurationsReference.rvt
        const referenceUrnId = 'dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y3V0aGFuYV9mb3JnZV90ZXN0L01ETS1NQVItQ29uZmlndXJhdGlvbnNSZWZlcmVuY2UucnZ0';
        // Model - MDM-MAR-ForgeConfigurations.rvt
        const configurationUrnId = 'dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6Y3V0aGFuYV9mb3JnZV90ZXN0L01ETS1Gb3JnZUNvbmZpZy1GaW5hbC5ydnQ';
        // Model - MDM-MAR-ForgeConfigurations-rev-2.rvt
        const configurationUrnIdRev2 = 'dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6bXlfYnVja2V0X2FsZXNzYW5kcm9fY3V0b2xvL01ETS1NQVItRm9yZ2VDb25maWd1cmF0aW9ucy1yZXYtMi5ydnQ';

        const urnId = configurationUrnIdRev2;

        // Start viewer
        forgeViewerInit(accessToken, urnId, viewerEl);
    });
};

window.forgeViewerRun = forgeViewerRun;
